import React from 'react';
import ICellProps, { ITranchRow } from './ICellProps';
import { BodyCell } from '@creditflowresearch/uilib/Table/DataTable';
import { formatNumberWithDecimals } from '@/creditflowresearch/ui/components/deals/helpers';
import ITranch from '@/creditflowresearch/domain/vo/Tranch/ITranch';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

const getTranchePrice = (tranche: ITranch): string | number => {
  let price = null;

  if (tranche.retained === true || tranche.interestOnly === true) {
    if (tranche.retained === true) {
      price = 'Retained';
    }

    if (tranche.interestOnly === true) {
      if (tranche.retained === true) {
        price += '; Int. Only';
      } else {
        price = 'Int. Only';
      }
    }
  } else if (tranche.issuePrice && tranche.issuePrice !== '0.000000') {
    price = formatNumberWithDecimals(tranche.issuePrice, 5);
  } else if (!tranche.issuePrice || tranche.issuePrice === '0.000000') {
    price = '-';
  }

  return price;
};

const getCell = ({ row: tranche }: ITranchRow) => getTranchePrice(tranche);

const PriceCell = ({
  rowIndex,
  tranche,
}: ICellProps) => (
  <BodyCell
    name="PriceCell"
    className={ alignStyles.alignRight }
    rowIndex={ rowIndex }
    rowData={ tranche }
    cellCallback={ getCell }
  />
);

export default PriceCell;
